<template>
    <div class="relative min-h-screen w-full flex bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/partnerships" class="opacity-50 hover:opacity-100">Partnerships</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/pipeline-partners" class="opacity-50 hover:opacity-100">Pipeline Partners</router-link>
                        <span class="mx-2">/</span>
                        <span>View Partner</span>
                    </div>
                    <div class="flex items-center justify-between mt-2">
                        <div class="font-bold">Pipeline Partner Details</div>
                        <router-link to="/pipeline-partners"
                            class="flex items-center gap-2 px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 text-sm font-medium">
                            <font-awesome-icon :icon="['fas', 'arrow-left']" />
                            Back to List
                        </router-link>
                    </div>
                </div>

                <div class="mt-4 flex-1 bg-white rounded-2xl border shadow-lg overflow-hidden">
                    <div v-if="isLoading" class="flex justify-center items-center py-20">
                        <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
                    </div>
                    <div v-else-if="error" class="flex flex-col justify-center items-center py-20 px-4">
                        <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="text-6xl text-red-400 mb-4" />
                        <p class="text-lg font-medium text-gray-700">{{ error }}</p>
                        <router-link to="/pipeline-partners" class="mt-4 text-ternary hover:underline">Back to Pipeline Partners</router-link>
                    </div>
                    <div v-else-if="item" class="p-6 md:p-8">
                        <pipeline-partners-view :item="item" :standalone="true" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gql from "graphql-tag";
import PipelinePartnersView from "./view.vue";

export default {
    name: "pipeline-partners-view-page",
    components: {
        PipelinePartnersView,
    },
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            item: null,
            isLoading: true,
            error: null,
        };
    },
    created() {
        this.fetchPartner();
    },
    watch: {
        token() {
            this.fetchPartner();
        },
    },
    methods: {
        async fetchPartner() {
            this.isLoading = true;
            this.error = null;
            this.item = null;

            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetCurrentPartnerByToken($token: String!) {
                            getCurrentPartnerByToken(token: $token) {
                                error
                                message
                                data {
                                    id
                                    token
                                    name
                                    logo
                                    entity
                                    industry
                                    industry_relation {
                                        id
                                        name
                                    }
                                    type_of_collaboration
                                    classifications
                                    status
                                    note
                                    parent_partner_id
                                    parent_partner {
                                        id
                                        name
                                        token
                                        is_pipeline
                                    }
                                    subsidiary_partners {
                                        id
                                        token
                                        name
                                        logo
                                        entity
                                        industry
                                        industry_relation {
                                            id
                                            name
                                        }
                                        type_of_collaboration
                                        classifications
                                        is_pipeline
                                    }
                                    contact_person {
                                        id
                                        name
                                        phone
                                        email
                                        designation
                                    }
                                    attachments {
                                        id
                                        file_name
                                        original_filename
                                        file_extension
                                        path
                                        uploaded_from
                                    }
                                    updated_at
                                    is_bot_approval
                                    is_md_approval
                                    is_line_manager_approval
                                }
                            }
                        }
                    `,
                    variables: { token: this.token },
                    fetchPolicy: "network-only",
                });

                const result = data.getCurrentPartnerByToken;
                if (result.error) {
                    this.error = result.message || "Failed to load partner";
                } else if (result.data && result.data.length > 0) {
                    this.item = result.data[0];
                } else {
                    this.error = "Partner not found";
                }
            } catch (err) {
                this.error = err.message || "Failed to load partner";
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
